module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Hvem er vi\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "30px"
    },
    attrs: {
      "src": "static/images/about.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottmo": "30px"
    },
    attrs: {
      "src": "static/images/IMG_0296.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0 0 20px"
    }
  }, [_vm._v("\n                    Historien bag P. Pedersen & Søn\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    P. Pedersen & Søn Fragt og Vognmandsfirma startede i 1921 og køres i dag af tredje generation.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Det var farfaren Peter Pedersen som startede firmaet august 1921. På det tidspunkt transporterede han alt - sten og grus, gods, korn, dyr og mennesker – med både hestevogn og bil. Han havde også et grusværk med gravemaskiner og gummiged. Med tiden blev det dog fragt, vognmandskørsel og dagligvare distribution der vægtede mest – indtil hans død i 1977.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Sønnen Mads Pedersen begyndte i firmaet da han fik kørekort, og han overtog styringen i begyndelsen af 1970érne. Mads Pedersen døde desværre i en alder af 50 år, hvorefter hans hustru Manna Pedersen kørte virksomheden videre indtil sønnerne Peder Bil og Karsten Bil tiltrådte virksomheden i 1976.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Peder Bil gik på efterløn i 2011, men følger stadig interesseret med i virksomheden. I dag køres firmaet alene af Karsten Bil, som i øvrigt havde 45 års jubilæum 1. marts 2021. Karsten Bil har to sønner, Lasse som er chauffør i firmaet og Thomas som bor og arbejder på Sjælland som sælger.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    I årene 2008–2018 havde Karsten Bil også virksomheden Kemi-Oil ApS (forhandling af cellulosefortynder, silikonefjerner, acetone mm. samt afhentning af spild i hele landet). Efter 10 gode år blev virksomheden solgt til Bent Hansens Malervarer.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Det gamle familiefirma, som 16. august 2021 runder 100 år, har i dag otte biler. Seks trækkere, en forvogn, en varebil + ti trailere, der dag og nat kører til og fra Ærø med gods og varer.\n                ")]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "30px"
    },
    attrs: {
      "src": "/static/images/people.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/Galleri_2.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4370c04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/about.vue
// module id = 279
// module chunks = 1